module.exports = (__webpack_require__(7))(144);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/ng2-translate/index.js from dll-reference vendor
// module id = 52
// module chunks = 0